<template>
    <div class="participant-projects">
        <div v-if="!hasData" class="empty">
            Информация об участии не заполнена
        </div>
        <div v-else class="content">
            <router-link
                v-for="project in items"
                :key="project.id"
                :to="getPathOptions(project)"
                class="item-card"
            >
                <div class="item-logo" :style="getLogo(project)"/>
                <div class="item-body">
                    <div class="item-name">
                        {{ project.name }}
                    </div>
                    <div class="item-status">
                        {{ getStatus(project) }}
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const getters = ['dictionaryByType'];
const actions = ['loadDictionaryItems'];

export default {
    name: "ParticipantProjects",

    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        ...mapGetters(getters),

        hasData() {
            return this.items && this.items.length;
        },
    },

    created() {
        this.loadDictionaryItems('stage_history');
    },

    methods: {
        ...mapActions(actions),

        getLogo(item) {
            return {
                'background-image': item && item.image_link ?
                    `url('${ item.image_link }')` :
                    `url('${ require('@/assets/images/image_not_found.svg') }')`,
            };
        },

        getPathOptions(project) {
            if (project) {
                return {
                    name: 'competitions',
                    params: { type: project.project_type, page: 1, id: project.season_id },
                    query: { mView: 'detail' },
                };
            }
            return null;
        },

        getStatus(item) {
            const statusesList = this.dictionaryByType('stage_history');
            const status = item && statusesList ? statusesList.find(el => {
                const userStatusId = item.nominations && item.nominations[0] ? item.nominations[0].userStatusId : null;
                return userStatusId ? el.id == userStatusId : false;
            }) : null;
            return status ? status.field_value : '';
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.participant-projects {
    .empty {
        font-family: 'Proxima Nova', sans-serif;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #98A0A9;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
        }
    }

    .item {
        &-card {
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: flex-start;
            margin: 0 0 rem(24);
            padding: rem(16);
            background: #FFFFFF;
            box-shadow: 0 rem(2) rem(8) rgba(155, 161, 166, 0.23626);
            border-radius: rem(4);
            cursor: pointer;

            @include on-mobile {
                display: block;
                margin: 0 0 mrem(24);
                padding: 0 0 mrem(8);
                border-radius: 0;
                box-shadow: none;
            }

            &:last-of-type {
                margin: 0;
            }
        }

        &-logo {
            flex: 0 0 auto;
            width: rem(129);
            height: rem(86);
            margin: 0 rem(16) 0 0;
            background: no-repeat center/contain;

            @include on-mobile {
                width: 100%;
                height: mrem(229);
                margin: 0 0 mrem(16) 0;
            }
        }

        &-name {
            margin: 0 0 rem(8);
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(18);
            line-height: rem(26);
            color: #2A2626;

            @include on-mobile {
                margin: 0 0 mrem(8);
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }

        &-status {
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
            }
        }
    }
}
</style>
